import React from "react";
import { Row, Col, Button, Card } from "antd";
import { HeartFilled } from '@ant-design/icons'

const { Meta } = Card;

const App = () => {

    return (<>
        <Row gutter={[0, 20]}>
            <Col>
                <text>根據您推薦的書籍 您可能會喜歡…</text>
            </Col>
            <Col span={24}>
                <Row justify={'center'} gutter={[0, 50]}>
                    <Col span={23}>
                        <Row wrap={false} style={{ width: '100%', overflowY: 'auto', height: 'fit-content' }} align={'middle'}>
                            <Col style={{ margin: '5px', cursor: 'pointer' }}>
                                <Card
                                    hoverable
                                    style={{
                                        width: 240,
                                    }}
                                    cover={<img alt="example" src="https://im1.book.com.tw/image/getImage?i=https://www.books.com.tw/img/001/095/81/0010958108.jpg&v=646df53bk&w=348&h=348" />}
                                >
                                    <Meta title="南方，寂寞鐵道：我們在時光列車上相遇" description={<><HeartFilled /><text>跟您類似的喜好，已有32人借閱此書</text></>} />
                                </Card>
                            </Col>
                            <Col style={{ margin: '5px', cursor: 'pointer' }}>
                                <Card
                                    hoverable
                                    style={{
                                        width: 240,
                                    }}
                                    cover={<img alt="example" src="https://im2.book.com.tw/image/getImage?i=https://www.books.com.tw/img/001/092/08/0010920815.jpg&v=623c4838k&w=348&h=348" />}
                                >
                                    <Meta title="貓主子的科學：喵皇賣萌大小事" description={<><HeartFilled /><text>跟您類似的喜好，已有14人借閱此書</text></>} />
                                </Card>
                            </Col>
                            <Col style={{ margin: '5px', cursor: 'pointer' }}>
                                <Card
                                    hoverable
                                    style={{
                                        width: 240,
                                    }}
                                    cover={<img alt="example" src="https://im2.book.com.tw/image/getImage?i=https://www.books.com.tw/img/001/095/65/0010956573.jpg&v=64538a2fk&w=348&h=348" />}
                                >
                                    <Meta title="電玩遊戲進化史【圖解漫畫版】：從桌遊、RPG、任天堂到VR，回味玩心設計大躍進的魅力指南" description={<><HeartFilled /><text>跟您類似的喜好，已有9人借閱此書</text></>} />
                                </Card>
                            </Col>
                            <Col style={{ margin: '5px', cursor: 'pointer' }}>
                                <Card
                                    hoverable
                                    style={{
                                        width: 240,
                                    }}
                                    cover={<img alt="example" src="https://im1.book.com.tw/image/getImage?i=https://www.books.com.tw/img/001/095/76/0010957634.jpg&v=646c4212k&w=348&h=348" />}
                                >
                                    <Meta title="快速開飯的5分鐘預漬備料魔法：只要學會就能10分鐘快速上桌，92道讓你天天省時輕鬆煮的美味提案！" description={<><HeartFilled /><text>跟您類似的喜好，已有21人借閱此書</text></>} />
                                </Card>
                            </Col>
                            {/* {Array(5).fill(0).map(() => (<>
                                <Col style={{ margin: '5px', cursor: 'pointer' }}>
                                    <Card
                                        hoverable
                                        style={{
                                            width: 240,
                                        }}
                                        cover={<img alt="example" src="https://im1.book.com.tw/image/getImage?i=https://www.books.com.tw/img/F01/978/67/F019786702.jpg&v=6482e30ek&w=375&h=375" />}
                                    >
                                        <Meta title="艾爾登法環：官方美術設定集（第一集）Elden Ring: Official Art Book Volume I" description={<><HeartFilled /><text>跟您類似的喜好，已有30人借閱此書</text></>} />
                                    </Card>
                                </Col>
                            </>)
                            )} */}
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    </>)
}

export default App